export const ACCESSDENIED: string = 'ACCESSDENIED';
export const CHANGE_CUSTOMER: string = 'CHANGE_CUSTOMER';
export const CHANGE_FACILITY: string = 'CHANGE_FACILITY';
export const OKAY: string = 'OKAY';
export const SUPERVISOR: string = 'SUPERVISOR';
export const WSADMIN: string = 'WSADMIN';
export const WSINVINQUIRE: string = 'WSINVINQUIRE';
export const WSORDCANCEL: string = 'WSORDCANCEL';
export const WSORDCREATE: string = 'WSORDCREATE';
export const WSORDINQUIRE: string = 'WSORDINQUIRE';
export const WSORDMODIFY: string = 'WSORDMODIFY';
export const WSREPORTADMIN: string = 'WSREPORTADMIN';
export const WSREPORTS: string = 'WSREPORTS';
